import * as Scrivito from "scrivito";

export const isActiveObj = (obj: Scrivito.Obj) => {
  if (!obj) {
    return false;
  }
  if (Scrivito.isInPlaceEditingActive()) {
    return true;
  }

  const from = obj.get("publishFrom");
  const until = obj.get("publishUntil");

  if (from && from instanceof Date && from.getTime() > Date.now()) {
    return false;
  }

  return !(until && until instanceof Date && until.getTime() < Date.now());
};
